import { render, staticRenderFns } from "./WpProductListSlider.vue?vue&type=template&id=b5f97836"
import script from "./WpProductListSlider.vue?vue&type=script&lang=js"
export * from "./WpProductListSlider.vue?vue&type=script&lang=js"
import style0 from "./WpProductListSlider.vue?vue&type=style&index=0&id=b5f97836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports